export default __webpack_public_path__ + "static/media/048-metal detector.041287c2.svg";